const CityCountryIndex = () => import('./views/CityCountryIndex.vue')
const CityCountryCreate = () => import('./views/CityCountryCreate.vue')
const CityCountryEdit = () => import('./views/CityCountryEdit.vue')

export default [
  {
    path: 'cities/countries',
    name: 'cities.countries.index',
    component: CityCountryIndex
  },
  {
    path: 'cities/countries/create',
    name: 'cities.countries.create',
    component: CityCountryCreate
  },
  {
    path: 'cities/countries/:countryId(\\d+)',
    name: 'cities.countries.edit',
    component: CityCountryEdit
  }
]
